export default __webpack_public_path__ + "assets/ico_step_4-b49bb33b.svg";